// Analyses status management router
export default [
  {
    path: 'analyses-status',
    name: 'analysisStatusManagement',
    redirect: 'analyses-status/index',
    component: () =>
      import(
        /* webpackChunkName: "analysesStatusManagement" */ '../views/analysesStatusManagement/AnalysesStatusManagement.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'analysisStatusManagementIndex',
        meta: {
          tabbable: true,
          tableKeys: ['analysesStatus'],
          filterKeys: ['analysesStatus'],
          formKeys: [],
          routePermissions: ['analysesStatusView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "analysesStatusManagementIndex" */ '../views/analysesStatusManagement/AnalysesStatusManagementIndex.vue'
          ),
      },
    ],
  },
];
